import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { BodyText, DisplayText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderShareHeader = () => {
  return (
    <View style={styles.container}>
      <DisplayText sizeMatch={['32']}>
        <FormattedMessage {...messages.title} />
      </DisplayText>

      <BodyText sizeMatch={['16']} style={styles.body}>
        <FormattedMessage {...messages.body} />
      </BodyText>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Invite your guests',
    description: 'Group Order Share | Modal | Title',
  },
  body: {
    defaultMessage: 'Share this link so everyone can add to the order.',
    description: 'Group Order Share | Modal | Body',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    gap: theme.spacing['2'],
  },
  body: {
    color: theme.colors.CHARCOAL,
  },
});
